import {NhostClient} from '@nhost/react'
import {CONFIG} from '../config'

export const appNhostClient: NhostClient = new NhostClient({
    ...CONFIG.nhost
})
